import React, { useState, useEffect } from "react";
import Hotspot from "../hotspot";
import Carousel from "../../sections/carousel";

const HotspotCarousel = ({
  initialIndex,
  onPageChange,
  items = [],
  forceReset = false
}) => {
  const [pagination, setPagination] = useState({
    index: initialIndex,
    page: initialIndex + 1
  });

  // preload images
  useEffect(() => {
    items.forEach(item => {
      const img = new Image();
      img.src = item.image.src;
    });
  }, [items]);

  useEffect(() => {
    if (forceReset) {
      // Resets the pagination when we change to a new carousel
      setPagination({ index: 0, page: 1 });
    }
  }, [forceReset]);

  useEffect(() => {
    setPagination({ index: initialIndex, page: initialIndex + 1 });
  }, [initialIndex]);

  useEffect(() => {
    onPageChange(pagination);
  }, [onPageChange, pagination]);

  const handlePreviousPage = () => {
    const { index, page } = pagination;
    // Jump to end if first page
    setPagination({
      index: page === 1 ? items.length - 1 : index - 1,
      page: page === 1 ? items.length : page - 1
    });
  };

  const handleNextPage = () => {
    const { index, page } = pagination;
    // Jump to beginning if last page
    setPagination({
      index: page === items.length ? 0 : index + 1,
      page: page === items.length ? 1 : page + 1
    });
  };

  const shouldReturnCarousel = () => items.length > 1;
  return shouldReturnCarousel() ? (
    <div className="carousel-container">
      <Carousel onPrev={handlePreviousPage} onNext={handleNextPage}>
        <div className={"hotspot"}>
          <Hotspot
            key={pagination.index}
            forceReset={forceReset}
            {...items[pagination.index]}
          />
        </div>
      </Carousel>
    </div>
  ) : (
    <div className={"hotspot"}>
      <Hotspot key={pagination.index} {...items[0]} />
    </div>
  );
};

export default HotspotCarousel;
